import { render, staticRenderFns } from "./comp_WhatsappChat.vue?vue&type=template&id=35db6807&scoped=true"
import script from "./comp_WhatsappChat.vue?vue&type=script&lang=js"
export * from "./comp_WhatsappChat.vue?vue&type=script&lang=js"
import style0 from "./comp_WhatsappChat.vue?vue&type=style&index=0&id=35db6807&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35db6807",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
